import "./style.css";
import { Alert, Box, CircularProgress, createTheme, FormControl, InputLabel, Modal, Snackbar, ThemeProvider } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ErrorHandling } from "../../components/Errors/Errors";
import { BlueHoverButton } from "../../components/Inputs/BlueHoverButton";
import { WhiteInput } from "../../components/Inputs/InputText";
import Lista from "../../components/Lista";
import { PopupExtraG } from "../../components/Popup/PopupExtraG";
import { Popup } from "../../components/Popup/Popup";
import servSolicitacaoCompartilhamento from "../../services/login/servSolicitacaoCompartilhamento";
import servConsultaDisponibilidade from "../../services/login/servConsultaDisponibilidade";
import { style as modalStyle } from "../../components/Loading/Loading";
import { OpcoesPeriodoDatas } from '../../components/Combobox/PeriodoDatas';
import servAnalises from "../../services/login/servAnalises";
import { logout } from "../../state/slices/userSlice";
import Cadastro from "./Cadastro";
import { ResultadoAnalise } from "./Cadastro/Analises/ResultadoAnalise/ResultadoAnalise";
import { columnsSolCompartilhamento } from "./Lista";
import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { OpcoesSituacaoSolCompartilhamento } from "../../components/Combobox/SituacaoSolCompartilhamento";
import { SearchFieldStyles } from "../../components/Searchfields/SearchFieldStyles";
import Select from 'react-select';
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import ptBR from "date-fns/locale/pt-BR";
import { retornaDatasCfeTipoPeriodo } from "../../infra/utils/RetornaDatasCfeTipoPeriodo";
import { SearchFieldStylesFiltro } from "../../components/Searchfields/SearchFieldStylesFiltro";
import { changeTab, newTab, setTabFromNewIndex } from "../../state/slices/tabsSlice";
import servFileIni from "../../services/login/servFileIni";
import { setCurrentSolicitacaoComp } from "../../state/slices/analisesSlice";
import { Dialog, DialogTitle, DialogContent, DialogActions, FormControlLabel, Checkbox, Typography } from "@mui/material";
import { format } from "date-fns";
import servParam from "../../services/login/servParam";
import servSolicitacaoCompartilhamentoDocs from "../../services/login/servSolicitacaoCompartilhamentoDocs";


const SolicitacaoCompartilhamento = ({ onDblClick }) => {
    // Store e Navegação
    const dispatch = useDispatch();
    const user = useSelector(state => state.user);
    const tabs = useSelector(state => state.tabs);
    const navigate = useNavigate();

    const [filtro, setFiltro] = useState("");
    const [openDialog, setOpenDialog] = useState(false);
    const [isInstalacaoFim, setIsInstalacaoFim] = useState(false);

    const [openDialogInicioInstalacao, setOpenDialogInicioInstalacao] = useState(false);
    const [openResultado, setOpenResultado] = useState(false);
    const [openDialogFimInstalacao, setOpenDialogFimInstalacao] = useState(false);
    const [dataInicioInstalacao, setDataInicioInstalacao] = useState(new Date(1900, 0, 1, 1, 1, 1, 1));
    const [dataTerminoInstalacao, setDataTerminoInstalacao] = useState(new Date(1900, 0, 1, 1, 1, 1, 1));
    const [filtroCodigo, setFiltroCodigo] = useState("");
    const [fazFiscalizacao, setFazFiscalizacao] = useState(false);
    const [dispMapa, setDispMapa] = useState(false);
    const [situacaoSolCompartilhamento, setSituacaoSolCompartilhamento] = useState([]);
    const [solCompartilhamento, setSolCompartilhamento] = useState([]);
    const [dataResultado, setDataResultado] = useState(null);
    const [openAnalise, setOpenAnalise] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");

    const [tipoPeriodo, setTipoPeriodo] = useState({ value: 8, label: 'Este mês' });
    const [tipoDataFiltro, setTipoDataFiltro] = useState("data-cadastro");
    const [dataInicialFiltro, setDataInicialFiltro] = useState(new Date());
    const [dataFinalFiltro, setDataFinalFiltro] = useState(new Date());

    const [openPopup, setOpenPopup] = useState(false);
    const [openConsultaHomolog, setOpenConsultaHomolog] = useState(false);
    const [recordForEdit, setRecordForEdit] = useState(null);

    // Carregamento e modais
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [openError, setOpenError] = useState(false);
    const [openErrorWindow, setOpenErrorWindow] = useState(false);
    const [openSuccess, setOpenSuccess] = useState(false);
    const [podeEnviarAnalise, setPodeEnviarAnalise] = useState(false);
    const [podeAnalisar, setPodeAnalisar] = useState(false);
    const [situacaoPodeRevisarAnalise, setSituacaoPodeRevisarAnalise] = useState(false);
    const [abrirMsgCancelamento, setAbrirMsgCancelamento] = useState(false);
    const [situacaoAguardandoInstalacao, setSituacaoAguardandoInstalacao] = useState(false);

    const theme = createTheme({
        components: {
            MuiIconButton: {
                styleOverrides: {
                    sizeMedium: {
                        color: "#d2d4d2"
                    }
                }
            }
        }
    });

    useEffect(() => {
        if (recordForEdit === null) {
            setPodeEnviarAnalise(false);
            return;
        }

        let situacao = recordForEdit?.Situacao || (recordForEdit?.row?.Situacao ?? 0);

        const situacaoPodeEnviarAnalise = [0, 2];
        const situacaoEmDigitacao = [0];
        const situacaoAguardandoInstalacao = [3];
        const situacaoPodeRevisarAnalise = [0, 6, 7];

        situacaoPodeEnviarAnalise.includes(situacao) ? setPodeEnviarAnalise(true) : setPodeEnviarAnalise(false);
        situacaoEmDigitacao.includes(situacao) ? setPodeAnalisar(false) : setPodeAnalisar(true);
        situacaoAguardandoInstalacao.includes(situacao) ? setSituacaoAguardandoInstalacao(true) : setSituacaoAguardandoInstalacao(false);
        situacaoPodeRevisarAnalise.includes(situacao) ? setSituacaoPodeRevisarAnalise(false) : setSituacaoPodeRevisarAnalise(true);
    }, [recordForEdit]);

    const handleCloseDialog = () => {
        setOpenDialogInicioInstalacao(false);
        setOpenDialogFimInstalacao(false);
        setOpenDialog(false);
        setAbrirMsgCancelamento(false);
    };

    useEffect(() => {
        const buscarParametros = async () => {
            try {
                const params = await servSolicitacaoCompartilhamento.BuscarParametros();
                if (params && params.Content && params.Content.length) {
                    setFazFiscalizacao(Boolean(params.Content[0]?.FazFiscalizacao));
                } else {
                    setFazFiscalizacao(true);
                }

            } catch {
                setFazFiscalizacao(true);
            }
        };

        const recuperarParametros = async () => {
            try {
                const response = await servConsultaDisponibilidade.BuscarParametros();

                if (response && response.Content.length) {
                    setDispMapa(Boolean(response.Content[0]?.DisponibilizaMapas));
                }
            }
            catch (err) {
                console.log(err);
            }
        }


        buscarParametros();
        recuperarParametros();
    }, []);

    const handleCloseSuccess = (event, reason) => {
        if (reason === 'clickaway') {
            setOpenSuccess(false);
        }

        setOpenSuccess(false);
    }

    // Chamadas a API
    // Listar inicial
    useEffect(() => {
        const recuperarDados = async (filtroDatas) => {
            try {
                setIsLoading(true);

                let dados;

                // Se não tiver situação ou data informada, faz o listar básico, só com a pesquisa geral
                if (!filtroDatas) {
                    dados = await servSolicitacaoCompartilhamento.listarCFiltros(user.codigoUsuario, "");
                } else {
                    let arraySituacoes = [];

                    arraySituacoes = situacaoSolCompartilhamento.map((item) => item.value);

                    dados = await servSolicitacaoCompartilhamento.listarCfeSituacaoOuData(user.codigoUsuario,
                        filtro,
                        filtroCodigo,
                        arraySituacoes,
                        tipoDataFiltro,
                        filtroDatas.dataInicial,
                        filtroDatas.dataFinal);
                }

                let content = dados?.Content;

                if (dados.Content.length === 0) {
                    return setIsLoading(false);
                }

                content && content.map((solCompartilhamento) => {
                    return solCompartilhamento.id = solCompartilhamento.Id
                });

                setSolCompartilhamento(content);

                setIsLoading(false);
            } catch (err) {
                setIsLoading(false);

                return ErrorHandling(
                    err?.response?.status,
                    err?.Message,
                    setOpenError,
                    setErrorMessage,
                    dispatch,
                    logout,
                    navigate,
                    err?.response?.data?.Message
                );
            }
        }

        const recuperarUltimoTipoPeriodoDefinido = async () => {
            try {
                setIsLoading(true);

                let dto = {
                    CodigoUsuario: user.codigoUsuario.toString(),
                    CodigoSecao: "TIPO_PERIODO_P3",
                    Chave: "IDTIPOPERIODOSOLCOMPARTILHAMENTO",
                    Conteudo: ""
                };

                let response = await servFileIni.Recuperar(dto);
                let novasDatas;

                if (response.Content.trim() !== "") {
                    let conteudo = Number(response.Content);
                    let labelTipoPeriodo = OpcoesPeriodoDatas.find((periodo) => periodo.value === conteudo).label;

                    await setarTipoPeriodoERedefinirDatas({ value: conteudo, label: labelTipoPeriodo });
                    novasDatas = retornaDatasCfeTipoPeriodo(conteudo);
                } else {
                    await setarTipoPeriodoERedefinirDatas({ value: 8, label: "Este mês" });
                    novasDatas = retornaDatasCfeTipoPeriodo(8); // 8 - Este mês
                }

                if (solCompartilhamento.length === 0) {
                    recuperarDados(novasDatas);
                }

                setIsLoading(false);
            } catch (err) {
                setIsLoading(false);

                return ErrorHandling(
                    err?.response?.status,
                    err?.Message,
                    setOpenError,
                    setErrorMessage,
                    dispatch,
                    logout,
                    navigate,
                    err?.response?.data?.Message
                );
            }
        }

        recuperarUltimoTipoPeriodoDefinido();
    }, []);

    const onClickPesquisar = async () => {
        try {
            setIsLoading(true);
            let dados;

            if (situacaoSolCompartilhamento.length === 0 &&
                (!dataInicialFiltro || dataInicialFiltro.toLocaleDateString() === "") &&
                (!dataFinalFiltro || dataFinalFiltro.toLocaleDateString() === "")) {
                dados = await servSolicitacaoCompartilhamento.listarCFiltros(user.codigoUsuario, filtro);
            } else {
                let arraySituacoes = [];

                arraySituacoes = situacaoSolCompartilhamento.map((item) => item.value);

                dados = await servSolicitacaoCompartilhamento.listarCfeSituacaoOuData(user.codigoUsuario,
                    filtro,
                    filtroCodigo,
                    arraySituacoes,
                    tipoDataFiltro,
                    dataInicialFiltro,
                    dataFinalFiltro);
            }

            let content = dados?.Content;

            content && content.map((solCompartilhamento) => {
                return solCompartilhamento.id = solCompartilhamento.Id
            });

            setIsLoading(false);

            setSolCompartilhamento(content);

            if (content.length === 0) {
                setErrorMessage("Não foram encontrados registros para sua pesquisa");
                setOpenError(true);
            }
        } catch (err) {
            setIsLoading(false);

            return ErrorHandling(
                err?.response?.status,
                err?.Message,
                setOpenError,
                setErrorMessage,
                dispatch,
                logout,
                navigate,
                err?.response?.data?.Message);
        }
    }

    const handleCloseError = (event, reason) => {
        if (reason === 'clickaway') {
            setOpenErrorWindow(false);
        }

        setOpenErrorWindow(false);
    }

    const cancelarOcupante = async () => {
        try {
            setIsLoading(true);

            await servSolicitacaoCompartilhamento.Cancelar(recordForEdit?.row?.Id || recordForEdit?.Id);

            setOpenSuccess(true);
            setAbrirMsgCancelamento(false);
            setSuccessMessage("Ocupante cancelado com sucesso.");
            setIsLoading(false);

            setTimeout(() => {
                setOpenPopup(false);
                onClickPesquisar();
            }, [1400]);

        } catch (err) {
            setIsLoading(false);
            setOpenErrorWindow(true);
            setAbrirMsgCancelamento(false);
            setErrorMessage(err?.response?.data?.Message);
            return;
        }
    }

    const abrirMsgCancelar = () => {
        if (recordForEdit === null) {
            setErrorMessage("É necessário selecionar um registro");
            return setOpenErrorWindow(true);
        }

        const situacoesCancelaveis = [6];

        if (situacoesCancelaveis.includes(recordForEdit?.row?.Situacao) || situacoesCancelaveis.includes(recordForEdit?.Situacao)) {
            setErrorMessage("A solicitação não pode ser cancelada, pois já está na situação 'Cancelada'.");
            return setOpenErrorWindow(true);
        }

        setAbrirMsgCancelamento(true);
    }

    const solicitarCancelamento = () => {
        const situacoesCancelaveis = [0, 1, 2];

        if (situacoesCancelaveis.includes(recordForEdit?.row?.Situacao) || situacoesCancelaveis.includes(recordForEdit?.Situacao)) {
            if (user.codigoUsuario !== (recordForEdit?.row?.CodigoResponsavelTecnico || recordForEdit?.CodigoResponsavelTecnico)) {
                setErrorMessage("Não é possível cancelar, este ocupante foi criado por outro responsável técnico");
                return setOpenErrorWindow(true);
            }

            return cancelarOcupante();
        }
        setErrorMessage("Só é possível cancelar ocupantes com situação em digitação, pendente de homologação ou revisão");
        return setOpenErrorWindow(true);
    }

    const handleTipoDataFiltro = (event) => {
        event.preventDefault();

        setTipoDataFiltro(event.target.value)
    }

    const setarTipoPeriodoERedefinirDatas = async (tipoPeriodo) => {
        try {
            setTipoPeriodo(tipoPeriodo);

            let datasCalculadas = retornaDatasCfeTipoPeriodo(tipoPeriodo?.value);
            setDataInicialFiltro(datasCalculadas.dataInicial);
            setDataFinalFiltro(datasCalculadas.dataFinal);

            let dto = {
                Chave: "IDTIPOPERIODOSOLCOMPARTILHAMENTO",
                Conteudo: tipoPeriodo.value.toString(),
                CodigoSecao: "TIPO_PERIODO_P3",
                CodigoUsuario: user.codigoUsuario.toString()
            };

            await servFileIni.Inserir(dto);
        } catch (err) {
            setIsLoading(false);
            setErrorMessage("Erro ao salvar tipo de período. Tente novamente.");
            setOpenError(true);
            return;
        }
    }

    const solicitarAnalise = async () => {
        if (recordForEdit === null) {
            setErrorMessage("É necessário selecionar um registro");
            return setOpenError(true);
        }

        try {
            setIsLoading(true);

            const idSolCompart = recordForEdit?.row?.Id || recordForEdit?.Id;

            const [docsObrigatorios, docsVinculados] = await Promise.all([
                servParam.RecuperarDocumentosObrigatorios(12),
                servSolicitacaoCompartilhamentoDocs.listar(idSolCompart)
            ]);

            const docsAtualizados = docsObrigatorios.Content.map((doc) => {
                const documentoVinculado = docsVinculados.Content?.find(
                    (docVinculado) =>
                        doc.Id == docVinculado.CodigoConfiguracaoDoc &&
                        doc.CodigoClassificacaoDoc == docVinculado.CodigoClassificacaoDoc
                );

                if (documentoVinculado) {
                    return {
                        ...doc,
                        CodigoDocumento: documentoVinculado.CodigoDocumento
                    };
                }

                return doc;
            });

            const docsObrigatoriosPendentes = docsAtualizados.filter(
                doc => doc.Obrigatorio === 1 && !doc.CodigoDocumento
            );

            if (docsObrigatoriosPendentes.length > 0) {
                const nomesDocs = docsObrigatoriosPendentes.map(doc => doc.Descricao).join(', ');
                
                setErrorMessage(`Existem documentos obrigatórios pendentes: ${nomesDocs}`);
                setIsLoading(false);
                return setOpenErrorWindow(true);
            }

            await enviar();
            setIsLoading(false);
        } catch (err) {
            setIsLoading(false);
            setErrorMessage(err?.response?.data?.Message || "Erro ao verificar documentos obrigatórios.");
            return setOpenErrorWindow(true);
        }
    }

    const onClickAbrirAnalisesAntigas = () => {
        if (recordForEdit === null) {
            setErrorMessage("É necessário selecionar um registro");
            return setOpenError(true);
        }

        const situacaoSemAnalise = 0;

        if (recordForEdit?.row?.Situacao === situacaoSemAnalise
            || recordForEdit?.Situacao === situacaoSemAnalise) {
            setErrorMessage("A solicitação ainda não foi enviada para análise, portanto não possui análises realizadas");
            return setOpenError(true);
        }

        const listaSolicitacaoSolComp = {
            Nome: "Análises da solicitação de compartilhamento",
            Aba: 12
        };

        let id = recordForEdit?.row?.Id || recordForEdit?.Id;

        dispatch(newTab(listaSolicitacaoSolComp));
        dispatch(setTabFromNewIndex(listaSolicitacaoSolComp.Aba));
        dispatch(setCurrentSolicitacaoComp(id));
    };

    const informarInicioInstalacao = async () => {
        if (recordForEdit === null) {
            setErrorMessage("É necessário selecionar um registro");
            return setOpenErrorWindow(true);
        }

        const situacaoAguardandoInstalacao = 3;

        if (!fazFiscalizacao || !(recordForEdit?.row?.Situacao === situacaoAguardandoInstalacao || recordForEdit?.Situacao === situacaoAguardandoInstalacao)) {
            setErrorMessage("A opção 'Informar Início da instalação' só está disponível quando o parâmetro 'Faz Fiscalização' está ativo e a solicitação está na situação 'Aguardando Instalação'.");
            return setOpenErrorWindow(true);
        }

        setIsLoading(true);

        try {
            const dados = await servSolicitacaoCompartilhamento.listarCFiltrosComCodigo(
                user.codigoUsuario,
                recordForEdit?.Id || recordForEdit?.row?.Id
            );

            if (dados?.Content?.length > 0) {
                const content = dados.Content[0];

                const dataInicio = content.DataInicioInstalacao && content.DataInicioInstalacao.substring(0, 10) !== "01/01/1900"
                    ? new Date(content.DataInicioInstalacao)
                    : new Date();

                setDataInicioInstalacao(dataInicio);
            } else {
                setDataInicioInstalacao(new Date());
            }

            setOpenDialogInicioInstalacao(true);
            setIsInstalacaoFim(false);
        } catch (error) {
            console.error("Erro ao buscar dados:", error);
            setDataInicioInstalacao(new Date());
        } finally {
            setIsLoading(false);
        }
    }

    const informarFimInstalacao = async () => {
        if (recordForEdit === null) {
            setErrorMessage("É necessário selecionar um registro");
            return setOpenErrorWindow(true);
        }

        const situacaoAguardandoInstalacao = 3;

        if (!fazFiscalizacao || !(recordForEdit?.row?.Situacao === situacaoAguardandoInstalacao || recordForEdit?.Situacao === situacaoAguardandoInstalacao)) {
            setErrorMessage("A opção 'Informar Fim da instalação' só está disponível quando o parâmetro 'Faz Fiscalização' está ativo e a solicitação está na situação 'Aguardando Instalação'.");
            return setOpenErrorWindow(true);
        }

        setIsLoading(true);

        try {
            const dados = await servSolicitacaoCompartilhamento.listarCFiltrosComCodigo(
                user.codigoUsuario,
                recordForEdit?.Id || recordForEdit?.row?.Id
            );

            if (dados?.Content?.length > 0) {
                const content = dados.Content[0];

                const dataInicio = content.DataTerminoInstalacao && content.DataTerminoInstalacao.substring(0, 10) !== "01/01/1900"
                    ? new Date(content.DataTerminoInstalacao)
                    : new Date();

                setDataTerminoInstalacao(dataInicio);
            } else {
                setDataTerminoInstalacao(new Date());
            }

            setOpenDialogFimInstalacao(true);
        } catch (error) {
            console.error("Erro ao buscar dados:", error);
            setDataTerminoInstalacao(new Date());
        } finally {
            setIsLoading(false);
        }
    }

    const enviar = async () => {
        try {
            const dto = {
                id: recordForEdit?.row?.Id || recordForEdit?.Id
            };

            await servSolicitacaoCompartilhamento.SolicitarAnalise(dto);

            setSuccessMessage("Alteração realizada com sucesso!");
            setOpenSuccess(true);
            onClickPesquisar();
            handleCloseDialog();
        } catch (error) {
            setOpenErrorWindow(true);
            setErrorMessage(error?.response?.data?.Message || "Erro ao solicitar análise.");
        }
    };

    const onClickAbrirResultadoAnalise = async () => {
        if (recordForEdit === null) {
            setErrorMessage("É necessário selecionar um registro");
            return setOpenError(true);
        }

        const response = await servAnalises.ListarSolicitacoesCompartilhamentoAnalise(user.codigoUsuario, recordForEdit?.Id || recordForEdit?.row?.Id, "");

        if (response?.Content?.length === 0) {
            setErrorMessage("Não há análises para esta solicitação de compartilhamento.");
            return setOpenErrorWindow(true);
        }

        const analise = response.Content.reduce((prev, current) => (prev.Analise > current.Analise) ? prev : current);

        setDataResultado(analise);
        setOpenResultado(true);
    }

    const enviarDataInicio = async () => {
        try {
            setIsLoading(true);

            const dados = await servSolicitacaoCompartilhamento.listarCFiltrosComCodigo(user.codigoUsuario, recordForEdit?.Id || recordForEdit?.row?.Id);
            let content = dados?.Content[0];

            await servSolicitacaoCompartilhamento.editar(
                content.Id,
                content.Analise,
                content.Situacao,
                content.CodigoResponsavelTecnico,
                content.CodigoOcupante,
                content.CodigoCidade,
                content.Bairro,
                content.TipoCabo,
                content.NomeRepresentante,
                content.CpfRepresentante,
                content.EmailRepresentante,
                dataInicioInstalacao,
                content.QtdePontos
            );

            setIsLoading(false);
            setOpenSuccess(true);
            setSuccessMessage("Data de início de instalação atualizada com sucesso.");

            setTimeout(() => {
                onClickPesquisar();
            }, 1000);

            handleCloseDialog();

        } catch (err) {
            setIsLoading(false);
            setErrorMessage(err?.response?.data?.Message || "Erro ao atualizar data");
            setOpenError(true);
        }
    };

    const enviarDataTermino = async () => {
        setIsInstalacaoFim(true);

        setIsLoading(true);
        try {
            const dto = {
                id: recordForEdit?.row?.Id || recordForEdit?.Id,
                DataTerminoInstalacao: dataTerminoInstalacao
            };

            await servSolicitacaoCompartilhamento.InformarInstalacao(dto);
            setIsLoading(false);

            setOpenSuccess(true);
            setSuccessMessage("Data de término de instalação atualizada com sucesso.");
            setTimeout(() => {
                onClickPesquisar();
            }, 1000);
            handleCloseDialog();
        } catch (err) {
            setIsLoading(false);
            setErrorMessage(err?.response?.data?.Message || "Erro ao atualizar data");
            setOpenError(true);
            return;
        }

    }

    const adicionarNovoOcupante = () => {
        setRecordForEdit(null);
        setOpenPopup(true);
    }

    return (
        <div className="solcompartilhamento-container">
            <div className="solcompartilhamentoFiltros">
                <FormControl>
                    <InputLabel shrink style={{ color: "#B8B8B8", marginLeft: "10px" }} >Pesquisa geral<FontAwesomeIcon style={{ marginLeft: "10px", width: "15px", height: "15px", cursor: "pointer" }} icon={faQuestionCircle} /></InputLabel>
                    <WhiteInput value={filtro} onChange={(e) => setFiltro(e.target.value)} placeholder="Pesquisa" id="pesquisa-nome" sx={{ width: "500px", margin: '0px 18px' }} />
                </FormControl>
            </div>
            <div className="solcompartilhamentoFiltros" style={{ marginTop: "20px" }}>
                <FormControl>
                    <InputLabel shrink style={{ color: "#B8B8B8", marginLeft: "10px" }} >Solicitação compartilhamento</InputLabel>
                    <WhiteInput value={filtroCodigo} onChange={(e) => setFiltroCodigo(e.target.value)} placeholder="Sol. compartilhamento" id="pesquisa-codigo" sx={{ width: "200px", margin: '0px 18px' }} />
                </FormControl>
                <FormControl variant="outlined" sx={{ width: "450px", marginRight: "20px" }}>
                    <InputLabel htmlFor="pesquisa-nome-situacao" shrink style={{ color: "#B8B8B8" }}>
                        Situação
                    </InputLabel>
                    <Select
                        isMulti={true}
                        value={situacaoSolCompartilhamento}
                        onChange={value => setSituacaoSolCompartilhamento(value)}
                        options={OpcoesSituacaoSolCompartilhamento}
                        styles={SearchFieldStyles}
                        placeholder="Situação"
                    />
                </FormControl>
            </div>
            <div className="solcompartilhamentoFiltros">
                <FormControl variant="outlined">
                    <InputLabel htmlFor="data-solcompartilhamento" shrink style={{ color: "#B8B8B8", marginTop: "20px", marginLeft: "10px" }} >
                        <select className="tipoDataFiltroConsulta" name="tipo-data" id="tipo-data" value={tipoDataFiltro} onChange={handleTipoDataFiltro}>
                            <optgroup>
                                <option value="data-cadastro" selected>Data cadastro</option>
                                <option value="data-prazo-analise">Data prazo análise</option>
                                <option value="data-aprovacao">Data aprovação</option>
                            </optgroup>
                        </select>
                    </InputLabel>
                    <div className="solcompartilhamentoDatas">
                        <Select
                            value={tipoPeriodo}
                            onChange={(e) => setarTipoPeriodoERedefinirDatas(e)}
                            options={OpcoesPeriodoDatas}
                            styles={SearchFieldStylesFiltro}
                            placeholder="Período"
                        />
                        <ThemeProvider theme={theme}>
                            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR} localeText={{ todayButtonLabel: "Hoje" }}>
                                <DatePicker
                                    fullWidth
                                    inputFormat="dd/MM/yyyy"
                                    value={dataInicialFiltro}
                                    onChange={(e) => setDataInicialFiltro(e)}
                                    renderInput={({ inputRef, inputProps, InputProps }) => (
                                        <>
                                            <WhiteInput ref={inputRef}  {...inputProps} sx={{ color: "#707070" }} />
                                            <span style={{ position: "absolute", top: 58, right: 250, color: "white", svg: "white", input: "white", label: "white" }}>
                                                {InputProps?.endAdornment}
                                            </span>
                                        </>
                                    )}
                                    componentsProps={{
                                        actionBar: {
                                            actions: ["today"]
                                        }
                                    }}
                                />
                            </LocalizationProvider>
                        </ThemeProvider>
                        <span style={{ color: "whitesmoke", margin: "9px 5px" }}>-</span>
                        <ThemeProvider theme={theme}>
                            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR} localeText={{ todayButtonLabel: "Hoje" }}>
                                <DatePicker
                                    fullWidth
                                    inputFormat="dd/MM/yyyy"
                                    value={dataFinalFiltro}
                                    onChange={(e) => setDataFinalFiltro(e)}
                                    renderInput={({ inputRef, inputProps, InputProps }) => (
                                        <>
                                            <WhiteInput ref={inputRef}  {...inputProps} sx={{ color: "#707070" }} />
                                            <span style={{ position: "absolute", top: 58, right: 30, color: "white", svg: "white", input: "white", label: "white" }}>
                                                {InputProps?.endAdornment}
                                            </span>
                                        </>
                                    )}
                                    componentsProps={{
                                        actionBar: {
                                            actions: ["today"]
                                        }
                                    }}
                                />
                            </LocalizationProvider>
                        </ThemeProvider>
                    </div>
                </FormControl>
                <BlueHoverButton variant="contained" onClick={onClickPesquisar} style={{ marginTop: "16.5px" }}>
                    Pesquisar
                </BlueHoverButton>
            </div>
            <div className="solcompartilhamento-botoes">
                <BlueHoverButton variant="contained" onClick={adicionarNovoOcupante}>Nova Sol. compartilhamento</BlueHoverButton>
                {podeEnviarAnalise && (
                    <BlueHoverButton variant="contained" onClick={solicitarAnalise}>Enviar para análise</BlueHoverButton>
                )}
                {podeAnalisar && <BlueHoverButton variant="contained" onClick={onClickAbrirAnalisesAntigas}>Análises</BlueHoverButton>}
                {situacaoPodeRevisarAnalise && <BlueHoverButton variant="contained" onClick={onClickAbrirResultadoAnalise}>Resultado da análise</BlueHoverButton>}
                {(fazFiscalizacao && situacaoAguardandoInstalacao) && <BlueHoverButton variant="contained" onClick={informarInicioInstalacao}>Informar início da instalação</BlueHoverButton>}
                {(fazFiscalizacao && situacaoAguardandoInstalacao) && <BlueHoverButton variant="contained" onClick={informarFimInstalacao}>Informar fim da instalação</BlueHoverButton>}
                <BlueHoverButton variant="contained" onClick={abrirMsgCancelar}>Cancelar</BlueHoverButton>
            </div>
            <div className="solcompartilhamento-lista" style={{ height: '520px' }}>
                <Modal open={isLoading}>
                    <Box style={modalStyle}>
                        <CircularProgress color="inherit" />
                    </Box>
                </Modal>
                <Lista
                    columns={columnsSolCompartilhamento}
                    rows={solCompartilhamento}
                    onDblClick={onDblClick ? onDblClick : setOpenPopup}
                    setSelectedData={setRecordForEdit}
                    hideFooter={false}
                    autoHeight={false}
                />
                <PopupExtraG
                    title="Solicitação compartilhamento"
                    openPopup={openPopup}
                    setOpenPopup={setOpenPopup}
                >
                    <Cadastro
                        setOpenPopup={setOpenPopup}
                        recordForEdit={recordForEdit}
                        pesquisar={onClickPesquisar}
                        origemSolicitacao={false}
                    />
                </PopupExtraG>
                <Popup title="Resultado da Análise" openPopup={openResultado} setOpenPopup={setOpenResultado} minHeight="100px">
                    <ResultadoAnalise
                        record={{}}
                        recordForView={dataResultado}
                        setIsLoading={setIsLoading}
                        fazFiscalizacao={fazFiscalizacao}
                        dispMapa={dispMapa}
                    />
                </Popup>
                <Dialog
                    open={openDialogInicioInstalacao}
                    onClose={handleCloseDialog}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    sx={{
                        '& .MuiPaper-root': {
                            backgroundColor: "#232323",
                            color: "whitesmoke",
                            padding: "20px",
                            borderRadius: "10px"
                        }
                    }}
                >
                    <DialogTitle id="alert-dialog-title" sx={{ fontWeight: "bold" }}>
                        {"Informar início da instalação"}
                    </DialogTitle>
                    <DialogContent>
                        <FormControl variant="outlined" style={{ margin: '20px', width: "80%" }}>
                            <InputLabel shrink style={{ color: "#B8B8B8" }} >
                                Data início da instalação
                            </InputLabel>
                            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
                                <DatePicker
                                    fullWidth
                                    inputFormat="dd/MM/yyyy"
                                    value={dataInicioInstalacao || new Date()}
                                    onChange={(newValue) => {
                                        setDataInicioInstalacao(newValue);
                                    }}
                                    renderInput={({ inputRef, inputProps, InputProps }) => (
                                        <>
                                            <WhiteInput ref={inputRef} {...inputProps} sx={{ color: "#fff" }} />
                                            <span style={{ position: "absolute", top: 38, right: 15 }}>
                                                {InputProps?.endAdornment}
                                            </span>
                                        </>
                                    )}
                                />
                            </LocalizationProvider>
                        </FormControl>
                    </DialogContent>
                    <DialogActions>
                        <BlueHoverButton
                            autoFocus
                            onClick={enviarDataInicio}
                        >
                            Continuar
                        </BlueHoverButton>
                        <BlueHoverButton
                            onClick={handleCloseDialog}>Cancelar</BlueHoverButton>
                    </DialogActions>
                </Dialog>
                <Dialog
                    open={openDialogFimInstalacao}
                    onClose={handleCloseDialog}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    sx={{
                        '& .MuiPaper-root': {
                            backgroundColor: "#232323",
                            color: "whitesmoke",
                            padding: "20px",
                            borderRadius: "10px"
                        }
                    }}
                >
                    <DialogTitle id="alert-dialog-title" sx={{ fontWeight: "bold" }}>
                        {"Informar término da instalação"}
                    </DialogTitle>
                    <DialogContent>
                        <FormControl variant="outlined" style={{ margin: '20px', width: "80%" }}>
                            <InputLabel shrink style={{ color: "#B8B8B8" }} >
                                Data término da instalação
                            </InputLabel>
                            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
                                <DatePicker
                                    fullWidth
                                    inputFormat="dd/MM/yyyy"
                                    value={dataTerminoInstalacao || new Date()}
                                    onChange={(newValue) => {
                                        setDataTerminoInstalacao(newValue);
                                    }}
                                    renderInput={({ inputRef, inputProps, InputProps }) => (
                                        <>
                                            <WhiteInput ref={inputRef} {...inputProps} sx={{ color: "#fff" }} />
                                            <span style={{ position: "absolute", top: 38, right: 15 }}>
                                                {InputProps?.endAdornment}
                                            </span>
                                        </>
                                    )}
                                />
                            </LocalizationProvider>
                        </FormControl>
                    </DialogContent>
                    <DialogActions>
                        <BlueHoverButton
                            autoFocus
                            onClick={enviarDataTermino}
                        >
                            Continuar
                        </BlueHoverButton>
                        <BlueHoverButton
                            onClick={handleCloseDialog}>Cancelar</BlueHoverButton>
                    </DialogActions>
                </Dialog>
                <Dialog
                    open={abrirMsgCancelamento}
                    onClose={handleCloseDialog}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    sx={{
                        '& .MuiPaper-root': {
                            backgroundColor: "#232323",
                            color: "whitesmoke",
                            padding: "20px",
                            borderRadius: "10px"
                        }
                    }}
                >
                    <DialogTitle id="alert-dialog-title" sx={{ fontWeight: "bold" }}>
                        {"Cancelar solicitação compartilhamento"}
                    </DialogTitle>
                    <DialogContent>
                        <Typography variant="body1" sx={{ color: 'whitesmoke' }}>
                            Tem certeza que deseja cancelar a solicitação compartilhamento selecionada?
                        </Typography>
                    </DialogContent>
                    <DialogActions>
                        <BlueHoverButton
                            autoFocus
                            onClick={solicitarCancelamento}
                        >
                            Continuar
                        </BlueHoverButton>
                        <BlueHoverButton
                            onClick={handleCloseDialog}>Cancelar</BlueHoverButton>
                    </DialogActions>
                </Dialog>
                <Snackbar open={openSuccess} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} autoHideDuration={6000} onClose={handleCloseSuccess}>
                    <Alert onClose={handleCloseSuccess} severity="success" sx={{ width: '100%' }}>
                        {successMessage}
                    </Alert>
                </Snackbar>
                <Snackbar open={openErrorWindow} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} autoHideDuration={6000} onClose={handleCloseError}>
                    <Alert onClose={handleCloseError} severity="error" sx={{ width: '100%' }}>
                        {errorMessage}
                    </Alert>
                </Snackbar>
            </div>
        </div>
    )
}

export { SolicitacaoCompartilhamento };